import React, { useState } from "react";
import Navigation from "../../components/Navigation";
import { Card, Col, Container, Row, Form } from "react-bootstrap";
import { FaGlobe, FaKey } from "react-icons/fa";
import rightArrow from "../../assets/images/icons/rightArrow.png";
import { NavLink, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const SettingPage = () => {
  const [notifications, setNotifications] = useState(true);
  return (
    <div>
      <Navigation nestedPath={"Profile"} />

      <Container className="mb-5 h-44 d-flex justify-content-center flex-column"> 
        <Row className="justify-content-center my-5 fs-18">
          <Col md={6}>
            {/* Notification Toggle */}
            <Card className="p-3 rounded-4 cursor border-0 mb-2 bg-light-gray d-flex flex-row align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <img loading="lazy"  src="/world.png" className="me-2" alt="" />
                <span>Notification</span>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={notifications}
                  onChange={() => setNotifications(!notifications)}
                />
                <span className="slider round"></span>
              </label>
            </Card>

            {/* Change Password */}
            <Link to={"/change-password"}>
              <Card className="p-3 mb-2 bg-light-gray cursor rounded-4 border-0  mt-4 d-flex flex-row align-items-center">
                <FaKey className="me-2" />
                <span>Change Password</span>      
              </Card>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SettingPage;
